import { requestGet } from "@/utils/dva16";
import { EGet, NGamerInsightNote, RSetState } from "./contants";

export default {
	namespace: NGamerInsightNote,
	state: {
		gamerInsightNotes: null,
		load: false,
	},
	reducers: {
		[RSetState](state, { payload }) {
			return {
				...state,
				...payload,
			};
		},
	},
	effects: {
		async [EGet]({ payload, callback }, { call, reducer, select, effect }) {
			reducer(RSetState, { load: true });
			let res = await requestGet("gamerInsightNotes", payload);
			reducer(RSetState, { gamerInsightNotes: res, load: false });
		},
	},
};
